import React from 'react';
import { AreaChart, Area, ResponsiveContainer, Tooltip as RechartsTooltip } from 'recharts';
import { SparkIcon } from '@spark';

/**
 * Throughput metric card with sparkline area chart.
 */
const ThroughputCard = ({ throughput }) => {
    const {
        currentRps = 0,
        peakRps = 0,
        changePercent = 0,
        series = [],
    } = throughput || {};

    const isPositive = changePercent >= 0;

    return (
        <div className="metric-card">
            <div className="metric-card__label">Throughput</div>

            <div className="metric-card__big-row">
                <span className="metric-card__big-number">
                    {currentRps.toFixed(1)}
                </span>
                <span className="metric-card__peak">/{peakRps} RPS Peak</span>
            </div>

            <div className="metric-card__comparison">
                <span className={`comparison-tag ${isPositive ? 'comparison-tag--positive' : 'comparison-tag--negative'}`}>
                    <SparkIcon slug={isPositive ? 'trending-up' : 'trending-down'} size="small" />
                    {Math.abs(changePercent)}% Vs Prev. hour
                </span>
            </div>

            <div className="metric-card__sparkline">
                <ResponsiveContainer width="100%" height="100%">
                    <AreaChart data={series} margin={{ top: 4, right: 0, left: 0, bottom: 0 }}>
                        <RechartsTooltip
                            formatter={(v) => [`${v} RPS`, 'Throughput']}
                            contentStyle={{ fontSize: 12 }}
                        />
                        <Area
                            type="monotone"
                            dataKey="rps"
                            stroke="#C483FB"
                            strokeWidth={2}
                            fill="none"
                            dot={false}
                            isAnimationActive={false}
                        />
                    </AreaChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default ThroughputCard;
